import { Button, Col, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import Select from "react-select";
import UnitMeasures from "../UnitMeasures";
import Swal from "sweetalert2";

export default function WorkOrderForm({ state, analisysTypes, operators, businessesActive, parameters, handleInputChange, handleSelectChange, submit, isAddingOrEditing, isRegistering, handleDeleteWorkOrders, userType }) {
    const { t } = useTranslation()
    const [params, setParams] = useState(state.params || [])
    const [selectedParameter, setSelectedParameter] = useState(null)
    const [addressesAux, setAddressesAux] = useState([])
    const [selectedAddressAux, setSelectedAddressAux] = useState(null)

    const businessesList = Array.isArray(businessesActive?.[0]) ? businessesActive[0] : (businessesActive || []);

    useEffect(() => {
        if (!state.business) {
            setAddressesAux([])
            setSelectedAddressAux(null)
            return
        }

        const selectedBusiness = businessesList.find(
            b => b._id === state.business
        )

        if (!selectedBusiness || !selectedBusiness.addresses) {
            setAddressesAux([])
            setSelectedAddressAux(null)
            return
        }

        const formatted = selectedBusiness.addresses.map(addr => ({
            label: `${addr.address}`,
            value: addr
        }))

        setAddressesAux(formatted)        
    }, [state.business])

    useEffect(() => {
        if (!state.address || !addressesAux.length) return

        const match = addressesAux.find(a =>
            a.value.address === state.address.address &&
            a.value.location === state.address.location &&
            a.value.province === state.address.province
        )

        if (match) {
            setSelectedAddressAux(match)
        }
    }, [state.address, addressesAux])

    const handleSelectAddressChange = (selected) => {
        setSelectedAddressAux(selected);
        handleInputChange({
            target: {
            name: "address",
            value: selected?.value || { address: "", province: "", location: "" }
            }
        })
    }

    const addParameter = () => {
        if (selectedParameter) {
            const paramData = parameters?.find(param => param?._id === selectedParameter?.value)
            if (paramData) {
                const newParam = {
                    parameterReferenced: selectedParameter?.value,
                    parameter: paramData?._id,
                    parameterName: paramData?.name,
                    unitMeasure: paramData?.unitMeasure || "",
                    minValue: paramData?.minValue || 0,
                    maxValue: paramData?.maxValue || 0
                }

                const updatedParams = [...(state.analisysType?.params || []), newParam]

                handleInputChange({
                    target: {
                        name: 'analisysType',
                        value: {
                            ...state.analisysType,
                            params: updatedParams
                        }
                    }
                })

                setSelectedParameter(null)
            }
        }
    }

    const removeParameter = (index) => {
        const updatedParams = state.analisysType.params.filter((_, i) => i !== index);
        handleInputChange({
            target: {
                name: 'analisysType',
                value: {
                    ...state.analisysType,
                    params: updatedParams
                }
            }
        })
    }

    const updateParameter = (index, key, value) => {
        const updatedParams = state.analisysType.params.map((param, i) =>
            i === index ? { ...param, [key]: key.includes("Value") ? Number(value) : value } : param
        )
        handleInputChange({
            target: {
                name: 'analisysType',
                value: {
                    ...state.analisysType,
                    params: updatedParams
                }
            }
        })
    }

    const handlePassToLaboratory = (e) => {
        e.preventDefault();

        handleInputChange({ target: { name: 'status', value: 'inProgress' } })

        Swal.fire({
            showConfirmButton: true,
            showDenyButton: true,
            confirmButtonText: t('global.yes'),
            denyButtonText: t('global.cancel'),
            denyButtonColor: '#61CE70',
            icon: 'question',
            text: t('admin.workOrders.areYouSurePassToLaboratory')
        }).then((result) => {
            if (result.isConfirmed) {
                submit(e, 'inProgress')
            } else {
                handleInputChange({ target: { name: 'status', value: 'new' } })
            }
        })
    }

    return (
        <Form onSubmit={submit} className="px-4 formulario">
            <Row className="my-3">
                <Col xs={12} md={2}>
                    <Form.Label>{t('admin.workOrders.numWorkOrder')}</Form.Label>
                    <Form.Control
                        className="sd-input"
                        type='text'
                        name='numWorkOrder'
                        value={state.numWorkOrder || ''}
                        onChange={handleInputChange}
                        required
                    />
                </Col>
                <Col xs={12} md={3}>
                    <Form.Label>{t('admin.workOrders.date')}</Form.Label>
                    <Form.Control
                        className="sd-input"
                        type='date'
                        name='date'
                        value={state.date || new Date().toISOString().split('T')[0]}
                        onChange={handleInputChange}
                        required
                    />
                </Col>
                <Col xs={12} md={7}>
                    <Form.Label>{t('admin.workOrders.operator')}</Form.Label>
                    <Select
                        className="select"
                        classNamePrefix="sd-select"
                        options={operators[0]?.map(op => ({ value: op?._id, label: op?.name })) || []}
                        value={operators[0]?.find(op => op?._id === state?.operator) ? {
                                value: state?.operator,
                                label: operators[0]?.find(op => op?._id === state.operator)?.name
                            }
                        :
                            null
                        }
                        onChange={(selected) => handleSelectChange({target: {name: 'operator', value: selected?.value}})}
                        required
                    />
                </Col>
            </Row>
            <Row className="my-3">
                <Col xs={12} md={6}>
                    <Form.Label>{t('admin.workOrders.business')}</Form.Label>
                    <Select
                        className="select"
                        classNamePrefix="sd-select"
                        onChange={(selected) => handleInputChange({ target: { name: 'business', value: selected.value } })}
                        options={businessesList?.map(b => ({ value: b?._id, label: b?.name }))}
                        value={businessesList?.find(b => b?._id === state.business) ? { value: state.business, label: businessesList.find(b => b._id === state.business)?.name } : null}
                        placeholder={t('admin.workOrders.selectBusiness')}
                        required
                    />
                </Col>
                <Col xs={12} md={6}>
                    <Form.Label>{t('admin.workOrders.businessBill')}</Form.Label>
                    <Select
                        className="select"
                        classNamePrefix="sd-select"
                        options={businessesActive[0]?.map(business => ({ value: business?._id, label: business?.name }))}
                        onChange={(selected) => handleInputChange({ target: { name: 'businessBill', value: selected.value } })}
                        value={businessesActive[0]?.find(b => b?._id === state.businessBill) ? { value: state.businessBill, label: businessesActive[0]?.find(b => b?._id === state.businessBill)?.name } : null}
                        placeholder={t('admin.workOrders.selectBusinessToBill')}
                    />
                </Col>
            </Row>
            {state.business && addressesAux.length > 0 && (
                <Row className="my-3">
                    <Col xs={12} md={6}>
                        <Form.Label>{t('admin.workOrders.address')}</Form.Label>
                        <Select
                            className="select"
                            classNamePrefix="sd-select"
                            options={addressesAux}
                            value={selectedAddressAux}
                            onChange={handleSelectAddressChange}
                            placeholder={t("admin.workOrders.selectAddress")}
                        />
                    </Col>
                </Row>
            )}
            <Row className="mt-0 mb-3">
                <Col xs={12}>
                    <Form.Label>{t('admin.workOrders.description')}</Form.Label>
                    <Form.Control
                        className="sd-input"
                        as='textarea'
                        name='description'
                        value={state.description || ''}
                        onChange={handleInputChange}
                    />
                </Col>
            </Row>
            <Row className="my-3">
                <Col>

                    {state?.status === 'inProgress' || state?.status === 'finished' ?
                        <>
                            <h5>{state?.analisysType?.name ? state?.analisysType.name  : ''}</h5>
                        </>

                    :
                        <>
                            <h5>{t('admin.workOrders.analisysType')}</h5>
                            <Select
                                className="select"
                                classNamePrefix="sd-select"
                                options={analisysTypes?.map(type => ({ value: type._id, label: type.name }))}
                                onChange={(selected) => handleSelectChange({ target: { name: "analisysType", value: selected.value } })}
                                value={state.analisysType?.name ? { value: state.analisysType.name, label: state.analisysType.name } : null}
                                placeholder={t('admin.workOrders.selectAnalisysType')}
                            />
                        </>
                    }
                </Col>
                <Col>

                    {state?.status === 'inProgress' || state?.status === 'finished' ?
                        <h5>{t('admin.workOrders.analisysQuantity')}: {state?.analisysQuantity ? state?.analisysQuantity  : ''}</h5>
                    :
                        <>
                            <h5>{t('admin.workOrders.analisysQuantity')}</h5>
                            <Form.Control
                                className="sd-input"
                                type='number'
                                min={1}
                                name='analisysQuantity'
                                value={state.analisysQuantity || 0}
                                onChange={handleInputChange}
                                readOnly={state?.status === 'inProgress' || state?.status === 'finished'}
                            />
                        </>
                    }
                </Col>
            </Row>
            {state?.status !== 'inProgress' && state?.status !== 'finished'
            ?
                <Row className="my-3">
                    <h5>{t('admin.analisysTypes.parameters')}</h5>
                    <Col xs={8}>
                        <Select
                            className="select"
                            classNamePrefix="sd-select"
                            options={parameters?.sort((a,b) => a.name.localeCompare(b.name)).map(param => ({ value: param._id, label: param.name }))}
                            onChange={setSelectedParameter}
                            value={selectedParameter}
                            placeholder={t('admin.analisysTypes.selectParameter')}
                            readOnly={state?.status === 'inProgress' || state?.status === 'finished'}
                        />
                    </Col>
                    <Col xs={4}>
                        <Button variant="fourth" onClick={addParameter}>{t('admin.analisysTypes.addParameter')}</Button>
                    </Col>
                </Row>
            :
                <></>
            }
            {state?.analisysType?.params?.length > 0 && state?.analisysType?.params?.map((param, index) => (
                <Row key={index} className="mb-2 border rounded p-2">
                    <Col xs={12}>
                        <Row>
                            <Col xs={6}>
                                {state?.status === 'inProgress' || state?.status === 'finished' ?
                                    param?.parameterName ? param?.parameterName  : ''
                                :
                                    <div className="d-flex align-items-center">
                                        <Button variant="third" onClick={() => removeParameter(index)}>
                                            <i className="fas fa-trash"></i>
                                        </Button>
                                        <Form.Control
                                            className="sd-input"
                                            type='text'
                                            value={param?.parameterName}
                                            readOnly
                                        />
                                    </div>
                                }
                            </Col>
                            <Col xs={6} md={2}>
                                {state?.status === 'inProgress' || state?.status === 'finished' ?
                                    t('admin.parameters.minValue') + ': ' + param?.minValue
                                :
                                    <Form.Control
                                        className="sd-input"
                                        type='number'
                                        step="any"
                                        placeholder={t('admin.parameters.minValue')}
                                        value={param.minValue}
                                        onChange={(e) => updateParameter(index, 'minValue', e.target.value)}
                                        readOnly={state?.status === 'inProgress' || state?.status === 'finished'}
                                    />
                                }
                            </Col>
                            <Col xs={6} md={2}>
                                {state?.status === 'inProgress' || state?.status === 'finished' ?
                                    t('admin.parameters.maxValue') + ': ' + param?.maxValue
                                :
                                    <Form.Control
                                        className="sd-input"
                                        type='number'
                                        step="any"
                                        placeholder={t('admin.parameters.maxValue')}
                                        value={param.maxValue}
                                        onChange={(e) => updateParameter(index, 'maxValue', e.target.value)}
                                        readOnly={state?.status === 'inProgress' || state?.status === 'finished'}
                                    />
                                }
                            </Col>
                            <Col xs={6} md={2}>
                                {state?.status === 'inProgress' || state?.status === 'finished' ?
                                    param?.unitMeasure ? param?.unitMeasure  : ''
                                :
                                    <UnitMeasures
                                        onChange={(selected) => updateParameter(index, 'unitMeasure', selected?.value)}
                                        value={param.unitMeasure ? { value: param.unitMeasure, label: t(param.unitMeasure) } : null}
                                    />
                                }
                            </Col>
                        </Row>
                    </Col>
                </Row>
            ))}

            <Row className="my-3">
                <Col xs={12} lg={4} className="my-2 ms-auto">
                    {userType === 'Admin' && (
                        <>
                            <Button variant='primary' type="submit" className="w-100 my-2">
                                {isRegistering ? (
                                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                ) : isAddingOrEditing === 'editing' ? (
                                    <>{t('global.edit')}</>
                                ) : (
                                    <>{t('global.register')}</>
                                )}
                            </Button>
                            {isAddingOrEditing === 'editing' && (
                                <>
                                    {state?.status === 'new' && (
                                        <Button variant="fourth" className="w-100 my-2 cursor" onClick={(e) => handlePassToLaboratory(e)}>
                                            {t('admin.workOrders.passToLaboratory')}
                                        </Button>
                                    )}
                                </>
                            )}
                        </>
                    )}
                </Col>
            </Row>
        </Form>
    );
}
